module.exports = __webpack_public_path__ + "img/2-1.f86f78a4.png";